// extracted by mini-css-extract-plugin
export default {"content":"iF-z"};